import styles from './Floor.module.css'
import {useNavigate} from "react-router-dom";
import {MAIN, PRIVACY} from "../../../../../utils/constants/routes";
import {ABOUT, CASES, SERVICES} from "../../../../../utils/constants/refs";
const Floor = (props: { whiteLinks?: boolean }) => {
    const { whiteLinks = false } = props
    const navigate = useNavigate();
    const handleNavigate = (url : string) => {
        navigate(url)
        window.scrollTo(0, 0);
    }
    return (
        <div className={`${styles.wrapper} ${whiteLinks ? styles.wrapperWhite : ''}`}>
            <div className={styles.leftBlock}>
                <img
                    onClick={() => handleNavigate(MAIN)}
                    src={whiteLinks ? "/logo-white.svg" : "/logo.svg"}
                    alt={"logo"}
                />
                Высококачественное программное обеспечение является ключом к вашему пути цифрового преобразования и конкурентного преимущества
            </div>
            <div className={`${styles.rightBlock} ${whiteLinks ? styles.white : ''}`}>
                <a href={ABOUT} onClick={() => handleNavigate(MAIN)}>О нас</a>
                <a href={SERVICES} onClick={() => handleNavigate(MAIN)}>Сервисы</a>
                <a href={CASES} onClick={() => handleNavigate(MAIN)}>Кейсы</a>
                <a onClick={() => handleNavigate(PRIVACY)}>Политика конфиденциальности</a>
            </div>
        </div>
    )
}

export default Floor